/* djimx-cart.js — hace funcional el "Agregar al carrito" de las tarjetas locales del home DJI MX.
   Los botones usan el marcador propio data-djimx-atc, separado del runtime de PageFly, y sus
   formularios NO traen <input name="id">. Aquí:
     1) si hay name="id", se usa;
     2) si no, se resuelve la variante desde /products/{handle}.js (primera disponible).
   Luego se agrega vía /cart/add.js con las secciones que exige el cart-drawer existente, se renderiza
   y abre ese drawer, y se emite cart:updated{source:'product'} para actualizar <cart-count>. */
(function () {
  function qtyOf(form) {
    var q = form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  }

  function handleFrom(scope) {
    var link = scope.querySelector('a[href*="/products/"], [data-href*="/products/"]');
    var href = link ? (link.getAttribute('href') || link.getAttribute('data-href')) : '';
    var m = String(href).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function originalLabel(btn) {
    if (!btn.__djimxOriginalLabel) btn.__djimxOriginalLabel = btn.textContent.trim();
    return btn.__djimxOriginalLabel;
  }

  function announce(btn, message) {
    var status = btn.parentNode && btn.parentNode.querySelector('[data-djimx-atc-status]');
    if (!status) {
      status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('data-djimx-atc-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      btn.insertAdjacentElement('afterend', status);
    }
    status.textContent = '';
    window.setTimeout(function () { status.textContent = message; }, 0);
  }

  function setLabel(btn, label, restoreAfter) {
    originalLabel(btn);
    window.clearTimeout(btn.__djimxLabelTimer);
    btn.textContent = label;
    if (restoreAfter) {
      btn.__djimxLabelTimer = window.setTimeout(function () {
        btn.textContent = originalLabel(btn);
      }, restoreAfter);
    }
  }

  function begin(btn) {
    btn.__djimxBusy = true;
    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, btn.getAttribute('data-adding') || 'Agregando…');
  }

  function done(btn) {
    btn.__djimxBusy = false;
    btn.removeAttribute('aria-busy');
  }

  function added(btn) {
    done(btn);
    setLabel(btn, btn.getAttribute('data-added') || 'Agregado', 1500);
    announce(btn, 'Producto agregado al carrito.');
  }

  function failed(btn, message) {
    done(btn);
    setLabel(btn, 'No se pudo agregar', 3000);
    announce(btn, message || 'No se pudo agregar el producto al carrito. Inténtalo de nuevo.');
  }

  function soldOut(btn) {
    done(btn);
    window.clearTimeout(btn.__djimxLabelTimer);
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = btn.getAttribute('data-soldout') || 'Agotado';
    announce(btn, 'Este producto no está disponible.');
  }

  function cartPayload(variantId, qty, drawer) {
    var payload = { items: [{ id: Number(variantId), quantity: qty }] };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(',');
      payload.sections_url = window.location.pathname;
    }

    return payload;
  }

  function renderCartDrawer(drawer, cartData) {
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    if (!cartData.sections || !cartData.sections['cart-drawer']) return false;

    drawer.renderContents(cartData);
    return true;
  }

  function addVariant(variantId, qty, btn) {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.setActiveElement === 'function') {
      drawer.setActiveElement(btn);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cartPayload(variantId, qty, drawer))
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var description = res.j && res.j.description;
          if (description) { try { console.warn('cart/add:', description); } catch (_) {} }
          failed(btn, description);
          return;
        }
        var drawerRendered = false;
        try {
          drawerRendered = renderCartDrawer(drawer, res.j);
        } catch (error) {
          try { console.warn('cart-drawer:', error); } catch (_) {}
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', cartData: res.j } }));
        added(btn);

        if (drawer && !drawerRendered) window.location.assign('/cart');
      })
      .catch(function (error) {
        try { console.warn('cart/add:', error); } catch (_) {}
        failed(btn);
      });
  }

  /* Captura sólo el marcador propio para que un listener externo no pueda consumir
     el evento antes de que llegue al manejador; los botones reales de PageFly no coinciden. */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-djimx-atc]');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || /disabled/.test(btn.className)) return;

    var form = btn.closest('form[action*="/cart/add"], .pf-product-form');
    var box = btn.closest('[data-pf-type="ProductBox"]') || form;
    if (!form && !box) return;

    e.preventDefault();
    if (btn.__djimxBusy) return;
    begin(btn);

    var qty = form ? qtyOf(form) : 1;
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) { addVariant(idInput.value, qty, btn); return; }

    /* Sin variante en el DOM: resolver desde el producto. */
    var handle = handleFrom(box) || handleFrom(form || box);
    if (!handle) { failed(btn); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('No se pudo cargar el producto.');
        return r.json();
      })
      .then(function (p) {
        var vs = p.variants || [];
        var v = vs.filter(function (x) { return x.available; })[0];
        if (v) addVariant(v.id, qty, btn);
        else soldOut(btn);
      })
      .catch(function (error) {
        try { console.warn('product:', error); } catch (_) {}
        failed(btn);
      });
  }, true);
})();
